import { render, staticRenderFns } from "./RunnitToolPromoCard.vue?vue&type=template&id=999330d2&scoped=true"
import script from "./RunnitToolPromoCard.vue?vue&type=script&lang=ts"
export * from "./RunnitToolPromoCard.vue?vue&type=script&lang=ts"
import style0 from "./RunnitToolPromoCard.vue?vue&type=style&index=0&id=999330d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999330d2",
  null
  
)

export default component.exports